import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { entWebsiteTestimonialFragment } from 'bundles/ent-website/queries/EntWebsiteTestimonial';

export const entWebsiteCaseStudyFragment = contentfulGql`#graphql
  ${entWebsiteTestimonialFragment}
  fragment EntWebsiteCaseStudy on EntWebsiteCaseStudy {
    slug
    headline
    teasersCollection(limit: 5) {
      items {
        slug
        orgName
        headline
        problem
        solution
        testimonial {
          ...EntWebsiteTestimonial
        }
      }
    }
  }
`;

export const entWebsiteBlockCaseStudyQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteCaseStudyFragment}
  query entWebsiteBlockCaseStudy($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteCaseStudy
      }
    }
  }
`;
